import EmployeeList from "./Components/EmployeeList";

export function App() {
  return <EmployeeList apiKey={window.entuitiveSettings.apiKey} />;
}
